import {Suspense, lazy} from 'react';
import {MobileOnlyView} from 'react-device-detect';
import {useSearchParams} from 'react-router';

import {useConsent} from '@/modules/common/context/Consent';
import {useSeaCampaign} from '@/modules/common/context/SeaCampaign';
import {useAppPromotionSplit} from '@/modules/common/hooks/useAppPromotionSplit';

const Layer = lazy(
  () => import('@/modules/common/components/AppPromotionLayer/components/Layer')
);

export const AppPromotionLayer = () => {
  const seaCampaign = useSeaCampaign();
  // only used to prevent some weird issues with the cookie consent layer
  // when both are rendered at the same time somehow you can not click anything
  // therefore we just wait until user gave some form of consent (status !== null) to get rid of the cookie layer
  const consent = useConsent();

  const [params] = useSearchParams();

  const appPromotionSplit = useAppPromotionSplit();
  const appPromotionSplitEnabled =
    appPromotionSplit.ready && appPromotionSplit.treatment !== 'off';
  const sharingSource = params.get('sharingSource')?.toLowerCase();

  if (
    (!seaCampaign.active && sharingSource !== 'app') ||
    consent.status === null ||
    !appPromotionSplitEnabled ||
    appPromotionSplit.config === null
  ) {
    return null;
  }

  return (
    <MobileOnlyView>
      <Suspense>
        <Layer
          hasDisguisedCloseButton={appPromotionSplit.treatment === 'disguised'}
          adjustTokens={{
            ios: appPromotionSplit.config.ios,
            android: appPromotionSplit.config.android,
          }}
          appearanceLimit={appPromotionSplit.config.appearanceLimit}
          reappearanceDelay={appPromotionSplit.config.reappearanceDelay}
        />
      </Suspense>
    </MobileOnlyView>
  );
};
